import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

export interface AcceptInvitationResult {
  status: "accepted" | "in_progress" | string;
  organization_id: string;
  account_id: string;
  role_id: string;
  /** Present only on 200 "accepted": a session inside the organization just joined. */
  access_token?: string;
  token_type?: string;
}

// Raw axios, not fetchV2: a 401 there redirects to /login and would drop the return path.
export const acceptInvitation = async (inviteToken: string, sessionToken: string) => {
  const res = await axios.post<AcceptInvitationResult>(
    `${API_URL}/api/v2/invitations/accept`,
    { token: inviteToken },
    { headers: { Authorization: `Bearer ${sessionToken}` } },
  );
  return res.data;
};
